// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Titre_titre__1O6a9 {\n  flex: 1 1;\n  font-weight: 700;\n  color: var(--color-bar);\n}\n.Titre_titre__1O6a9.Titre_mobile__3jgkM {\n  font-size: 16px;\n}\n.Titre_titre__1O6a9.Titre_desktop__30Gld {\n  font-size: 20px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Misc/Titre.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB","sourcesContent":[".titre {\n  flex: 1;\n  font-weight: 700;\n  color: var(--color-bar);\n}\n.titre.mobile {\n  font-size: 16px;\n}\n.titre.desktop {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titre": "Titre_titre__1O6a9",
	"mobile": "Titre_mobile__3jgkM",
	"desktop": "Titre_desktop__30Gld"
};
export default ___CSS_LOADER_EXPORT___;
